var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.476.72A.827.827 0 0 1 4.644.657l6.364 5.727a.827.827 0 0 1 0 1.23l-6.364 5.727a.827.827 0 0 1-1.107-1.23L9.217 7l-5.68-5.112A.827.827 0 0 1 3.476.719z"
})));
SvgNavChevron.displayName = "SvgNavChevron";
export { SvgNavChevron as ReactComponent };
export default SvgNavChevron;